module.exports = __webpack_public_path__ + "img/SmartX_Logo.71d3b4c9.png";